import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useCategories } from "@/lib/queries";
import { getIcon } from "@/lib/icons";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function ServiceCategories() {
  const { data: categories = [] } = useCategories();

  return (
    <section data-testid="services-section" className="obsidian py-24 sm:py-32">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-end">
          <SectionHeading
            number="01"
            overline="Hizmetlerimiz"
            title="Aracınız için eksiksiz koruma yelpazesi"
            subtitle="Boya korumadan iç temizliğe, PPF'ten cam filmine — premium araçlar için tasarlanmış profesyonel çözümler."
          />
          <Link
            to="/hizmetler"
            data-testid="all-services-link"
            className="group hidden shrink-0 items-center gap-2 border border-white/15 px-6 py-3.5 font-oswald text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-gold/50 hover:text-gold sm:inline-flex"
          >
            Tüm Hizmetler <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div data-testid="services-bento-grid" className="mt-14 grid auto-rows-[210px] grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => {
            const Icon = getIcon(c.icon);
            const big = i === 0;
            const wide = i === 5;
            const span = big ? "sm:col-span-2 lg:row-span-2" : wide ? "lg:col-span-2" : "";
            return (
              <Reveal key={c.slug} delay={Math.min(i * 0.04, 0.25)} className={span}>
                <Link
                  to={`/hizmetler/kategori/${c.slug}`}
                  data-testid={`category-card-${c.slug}`}
                  className="group relative flex h-full flex-col justify-end overflow-hidden border border-white/10 bg-neutral-900 transition-colors duration-300 hover:border-gold/40"
                >
                  <img
                    src={c.image && c.image.startsWith("/api/files/") ? `${c.image}?w=960` : c.image}
                    alt={c.name}
                    loading="lazy"
                    decoding="async"
                    className="absolute inset-0 h-full w-full object-cover opacity-40 grayscale-[0.25] transition-all duration-700 group-hover:scale-105 group-hover:opacity-60 group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#070707] via-[#070707]/55 to-[#070707]/10" />
                  <span className="absolute left-5 top-5 font-oswald text-sm font-bold tracking-[0.2em] text-white/40 transition-colors group-hover:text-gold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center border border-white/15 bg-black/40 text-white opacity-0 transition-all duration-300 group-hover:border-gold group-hover:bg-gold group-hover:text-black group-hover:opacity-100">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                  <div className="relative z-10 p-6">
                    <span className="flex h-10 w-10 items-center justify-center border border-gold/30 bg-black/40 text-gold backdrop-blur-sm">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className={`mt-4 font-display font-medium text-white ${big ? "text-2xl sm:text-3xl" : "text-xl"}`}>{c.name}</h3>
                    <p className="mt-2 text-sm text-neutral-300 line-clamp-2">{c.short}</p>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <Link
          to="/hizmetler"
          className="mt-6 flex items-center justify-center gap-2 border border-white/15 px-5 py-4 font-oswald text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-gold/50 hover:text-gold sm:hidden"
        >
          Tüm Hizmetler <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
